// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606240903/js/" + chunkId + "." + {"44":"655a7e0e","225":"6c075bc5","481":"4b17ca78","486":"6721fdb1","770":"15d43674"}[chunkId] + ".0.47729465492137435.chunk.js";
};